export default {
	"lanEnTxt": '英文',
	"lanZhTxt": '中文',
	"login": '登录',
	"register": '注册',
	"confirmDialog": {
		"logoutTitle": "提示",
		"logoutMsg": "是否要退出登录？",
		"confirmBtn": "是",
		"cancelBtn": "否",
		"logoutErr": "退出登录异常："
	},
	"userTopBar": {
			"welcome": "HI 欢迎进入",
			"systemName": "至隆物流系统",
			"memberId": "会员编号："
		},
		"header": {
			"nav": {
			"home": "首页",
			"logisticsQuery": "物流查询",
			"shopIndex": "代购商城",
			"freightEstimate": "运费估算",
			"mainBusiness": "主营业务",
			"latestNews": "最新资讯",
			"faq": "常见问题",
			"aboutUs": "关于我们"
		},
		"userName": "张德帅",
		"logout": "退出",
		"breadcrumb": {
			"label": "当前位置：",
			"home": "首页",
			"newsPage": "最新资讯",
			"backBtn": "返回"
		}
	},
	"footer": {
		"friendLinks": {
			"label": "友情链接",
			"baidu": "百度一下",
			"fengchi": "凤池天下",
			"douyin": "抖音"
		},
		"cols": {
			"resource": {
				"title": "资源",
				"latestNews": "最新消息",
				"faq": "常见问题"
			},
			"express": {
				"title": "快递",
				"prohibitedItems": "违禁物品禁存",
				"serviceTerms": "注册服务条款"
			},
			"solutions": {
				"title": "解决方案",
				"myOrder": "我的订单",
				"shippingTutorial": "海运教程",
				"orderManagement": "订单管理",
				"logisticsQuery": "物流查询",
				"shopIndex": "代购商城"
			},
			"about": {
				"title": "关于",
				"express100": "快递100",
				"aboutUs": "关于我们",
				"shentong": "申通快递",
				"yuantong": "圆通快递",
				"zhongtong": "中通快递"
			}
		},
		"contact": {
			"title": "关注或者联系我们",
			"desc": "添加至隆公众号、小程序",
			"hotline": "咨询热线",
			"btnText": "联系我们",
			"btnText1": "国内电话",
			"btnText2": "国际电话",
			"btnText3": "微信"
		},
		"copyright": {
			"text": "Copyright©2016-2020. All rights reserved.易境通散货拼柜",
			"icp": "粤ICP备15111761号易境通海运技术支持"
		}
	},
	"userPageLeft":{
		"txt1": "首页",
		"txt2": "快件下单",
		"txt3": "我的订单",
		"txt4": "地址管理",
		"txt5": "唛头管理",
		"txt6": "仓库地址查询",
		"txt7": "个人资料",
		"txt8": "常见问题",
		"txt9": "联系客服",
		"txt10": "用户协议",
		"txt11": "退出登录",
	},
	"userPageL":{
		"txt1": "首页",
		"txt2": "快件下单",
		"txt3": "集运订单",
		"txt4": "我的包裹",
		"txt5": "代购订单",
		"txt6": "优惠券",
		"txt7": "我的收藏",
		"txt8": "地址管理",
		"txt9": "仓库地址查询",
		"txt10": "消息通知",
		"txt11": "个人资料",
		"txt12": "常见问题",
		"txt13": "用户协议",
		"txt14": "退出登录",
	},
	"indexHme":{
		"txt1": "选物流,就选至隆",
		"txt2": "速度服务",
		"txt3": "双在线",
		"txt4": "使命必达",
		"txt5": "超靠谱",
		"txt6": "起运地",
		"txt7": "请选择",
		"txt8": "目的地",
		"txt9": "重量",
		"txt10": "长宽高",
		"txt11": "查询",
		"txt12": "业务流程",
		"txt13": "将货物寄到我们仓库 您坐等签收通知",
		"txt14": "我们的优势",
		"txt15": "速度，价格，安全，带给你全程贴心服务",
		"txt16": "安心交给我们",
		"txt17": "智能物流是利用集成智能化技术，使物流系统能模仿人的只能，具有思维感知推理判断和自行解决五六种某些问题的能力。",
		"txt18": "国际物流资讯",
		"txt19": "为你提供最新的行业资讯，动态消息",
		"txt20": "广州市甲壳虫数字",
		"txt21": "易境通是广州市甲壳虫数字科技有限公司旗下",
		"txt22": "腾讯云启创新生态是腾讯CSIG(云与智慧产业事业群)面向「中国企服创新公司」的孵化与合作窗口以资金租资源帮助初创企业快速发展。目前，业务主要包括加速优质企服公司成长的产业加速器服务大企业创新的产业共创营以及投资。",
		"txt23": "查看详情",
		"txt24": "请输入",
		"txt25": "长",
		"txt26": "宽",
		"txt27": "高",
		"txt28": "搜索国家/地区",
		"txt29": "无匹配结果",
	},
	"indexSeach":{
		"t1":"「物流查询」是帮您实时掌握货物动态的便捷工具!输入运单，即可随时查看货物位置、运输状态(如已揽收、在途、派送中)预计到达时间等信息，支持官网、APP、小程序等多平台查询。异常情况(如延误、破损)实时预警，助您轻松跟踪货物轨迹高效管理物流进度，让货物运输全程透明可控。",
		"t2": "请输入运单号",
		"t3": "查询",
		"t4": "暂无物流信息",
		"t5": "始发仓",
		"t6": "收货地址",
		"t7": "入仓号",
		"t8": "当前轨迹",
		"t9": "收缩",
		"t10": "展开",
		"t11": "请输入运单号或入仓号",
		"t12": "复制成功",
	},
	"indexFreight":{
		"t1":'「运费估算」是帮您快速预判物流成本的实用工具!输入货物重量、体积、运输目的地及方式(海运/空运陆运等) 系统自动匹配计费规则，实时生成包含运费估算的报价。支持多方案对比，助您提前规划预算、优化物流选择，发货前心中有数省时省力更省钱。',
		"t2":'',
		"t3":'起运地',
		"t4":'请选择',
		"t5":'目的地',
		"t6":'重量',
		"t7":'请输入',
		"t8":'长宽高',
		"t9":'长',
		"t10":'宽',
		"t11":'高',
		"t12":'查询',
		"t122":'暂无物流信息',
		"t13":'始发仓',
		"t14":'收货地址',
		"t15":'商品重量',
		"t16":'计算重量',
		"t17":'商品体积',
		"t18":'计算体积',
		"t19":'详情介绍',
		"t20":'下单',
		"t21":'描述',
		"t22":'出货渠道',
		"t23":'请选择起运地',
		"t24":'请选择目的地',
		"t25":'请输入重量',
		"t26":'请输入长',
		"t27":'请输入宽',
		"t28":'请输入高',
		"t29":'搜索国家/地区',
		"t30":'无匹配结果',
	},
	"indexFMsg":{
		"t1":"选物流, 就选至隆",
		"t2":"速度服务",
		"t3":"双在线",
		"t4":"使命必达",
		"t5":"超靠谱",
		"t6":"送达时间",
		"t7":"目的地",
		"t8":"计费方式",
		"t9":"首重续重",
		"t10":"阶梯价格",
		"t11":"多级续重",
		"t12":"阶梯首重续重",
		"t13":"体积计算",
		"t14":"长",
		"t15":"宽",
		"t16":"高",
		"t17":"计费标准",
		"t18":"首重",
		"t19":"续重",
		"t20":"最大限重",
		"t21":"渠道规则限制",
		"t22":"暂无",
		"t23":"注意事项",
		"t24":"可寄物品",
		"t25":"报价标准",
	},
	"newsList":{
		"t1":"暂无相关信息",
	},
	"newsMsg":{
		"t1":"文章详情",
		"t2":"发布日期",
		"t3":"上一篇",
		"t4":"下一篇",
	},
	"Business":{
		"t1":"至隆 - 主营业务",
		"t2":"危险品标志  海运赔偿  敏感物等",
	},
	"other":{
		"t1":"常见问题",
		"t2":"公告",
	},
	"userCenter":{
		"t1":"运输信息",
		"t2":"全部订单",
		"t3":"仓库地址",
		"t4":"查看更多",
		"t5":"仓库名称",
		"t6":"邮政编码",
		"t7":"联系人",
		"t8":"联系电话",
		"t9":"收货地址",
		"t10":"快捷通道",
		"t11":"最新订单",
		"t12":"全部订单",
		"t13":"暂无订单信息",
		"t14":"序号",
		"t15":"入仓号",
		"t16":"下单时间",
		"t17":"出发地",
		"t18":"运输方式",
		"t19":"目的地",
		"t20":"状态",
		"t21":"操作",
		"t22":"待入库",
		"t23":"已入库",
		"t24":"已装箱",
		"t25":"运输中",
		"t26":"待签收",
		"t27":"已签收",
		"t28":"作废",
		"t29":"查看",
		"link1":"快件下单",
		"link2":"我的订单",
		"link3":"唛头管理",
		"link4":"物流查询",
		"link5":"运费估算",
		"link6":"仓库地址",
		"link7":"个人资料",
		"link8":"常见问题",
		"link9":"用户协议",
	},
	"uinfo": {
	  "t1": "个人资料",
	  "t2": "头像",
	  "t3": "昵称",
	  "t4": "请输入昵称",
	  "t5": "国家",
	  "t6": "请选择",
	  "t7": "手机号码",
	  "t8": "请输入手机号码",
	  "t9": "绑定",
	  "t10": "微信",
	  "t11": "请输入微信号",
	  "t12": "性别",
	  "sex1":'男',
	  "sex2":'女',
	  "t13": "城市",
	  "t14": "请输入城市",
	  "t15": "邮箱",
	  "t16": "请输入邮箱",
	  "t17": "请输入whatsapp",
	  "t18": "保存",
	  "t19": "绑定手机号",
	  "t20": "绑定邮箱",
	  "t21": "验证码",
	  "t22": "请输入验证码",
	  "t23": "获取验证码",
	  "t24": "返回",
	  "t25": "确定",
	  "t26": "搜索国家/地区",
	  "t27": "无匹配结果",
	},
	"point": {
		"t1": "仓库地址查询",
		"t2": "请输入联系人",
		"t3": "请输入电话号码",
		"t4": "请输入详细地址",
		"t5": "查询",
		"t6": "邮编",
		"t7": "复制地址",
	},
	"marks": {
		"t1": "唛头管理",
		"t2": "暂无相关信息",
		"t3": "默认",
		"t4": "编辑",
		"t5": "删除",
		"t6": "添加唛头",
		"t7": "修改唛头",
		"t8": "唛头名称",
		"t9": "请输入唛头名称",
		"t10": "联系电话",
		"t11": "请输入联系电话",
		"t12": "是否默认",
		"t13": "是",
		"t14": "否",
		"t15": "返回",
		"t16": "确认修改",
		"t17": "确认添加",
	},
	"olist": {
		"t1": "请输入订单号/入仓号/唛头",
		"t2": "搜索",
		"t3": "下单时间",
		"t4": "请选择",
		"t5": "全部月份",
		"t6n": "序号",
		"t6": "图片",
		"t7": "入仓号",
		"t8": "唛头",
		"t9": "重量(kg)",
		"t10": "体积(㎡)",
		"t11": "运输方式",
		"t12": "出发地",
		"t13": "目的地",
		"t14": "下单时间",
		"t15": "状态",
		"t16": "操作",
		"t17": "待入库",
		"t18": "已入库",
		"t19": "已装箱",
		"t20": "运输中",
		"t21": "待签收",
		"t22": "已签收",
		"t23": "作废",
		"t24": "编辑",
		"t25": "取消",
		"t26": "删除",
		"t27": "签收",
		"t28": "查看",
		"hb1": "取消订单",
		"hb2": "取消信息",
		"hb3": "请输入取消信息",
		"hb3n": "请上传取消图片",
		"hb4": "取消图片",
		"hb5": "返回",
		"hb6": "确认取消",
		"hb7": "删除订单",
		"hb8": "确定删除该订单吗？",
		"hb9": "确认删除",
		"hb10": "签收订单",
		"hb11": "签收备注",
		"hb12": "请输入签收备注",
		"hb12n": "请上传签收照片",
		"hb13": "签收照片",
		"hb14": "确认签收",
		"all": "全部",
	},
	"omsg": {
		"t1": "当前位置",
		"t2": "我的订单",
		"t3": "订单详情",
		"t4": "始发仓",
		"t5": "收货地址",
		"t6": "入仓号",
		"t7": "基本信息",
		"t8": "唛头",
		"t9": "运输方式",
		"t10": "付款人",
		"t11": "发货人",
		"t12": "收货人",
		"t13": "双方支付",
		"t14": "报送方式",
		"t15": "我司全代",
		"t16": "自单代报",
		"t17": "收货方式",
		"t18": "自提",
		"t19": "派送",
		"t20": "仓位号",
		"t21": "暂无",
		"t22": "货位号",
		"t23": "联系电话",
		"t24": "下单时间",
		"t25": "备注",
		"car1": "汽车出口资料",
		"car2": "暂无相关信息",
		"car3": "登记证",
		"car4": "查看",
		"car5": "行驶证",
		"car6": "合同",
		"car7": "许可证",
		"car8": "其他",
		"car9": "公里数图片",
		"car10": "公里数",
		"car11": "联系方式",
		"pay1": "费用信息",
		"pay2": "支付明细",
		"pay3": "支付状态",
		"pay4": "待支付",
		"pay5": "已支付",
		"pay6": "部分支付",
		"pay7": "运费",
		"pay8": "增值服务",
		"pay9": "应付金额(运费+增值服务)",
		"pay10": "实付金额",
		"pay11": "已支付",
		"pay12": "待支付",
		"pay13": "操作",
		"pay14": "查看运费明细",
		"o1": "物流情况",
		"o2": "当前轨迹",
		"gys1": "供应商信息",
		"gys2": "姓名",
		"gys3": "联系电话",
		"g1": "产品信息",
		"g2": "序号",
		"g3": "图片",
		"g4": "快递单号",
		"g5": "品名",
		"g6": "重量(kg)",
		"g7": "体积(㎡)",
		"g8": "货值(￥)",
		"g9": "数量",
		"g10": "打包方式",
		"g11": "打包号",
		"g12": "货物类型",
		"g13": "总货值(￥)",
		"g14": "总数量",
		"ku1": "入库信息",
		"ku2": "体积",
		"ku3": "货架号",
		"ku4": "重量",
		"ku5": "入库时间",
		"ku6": "入库图片",
		"ku7": "入库视频",
		"ku8": "装柜信息",
		"ku9": "装柜号",
		"ku10": "装柜尺寸",
		"ku11": "装柜图片",
		"ku12": "装柜视频",
		"btn1": "取消",
		"btn2": "删除",
		"btn3": "编辑",
		"btn4": "签收",
	},
	"ofee": {
		"t1": "当前位置",
		"t2": "我的订单",
		"t3": "订单详情",
		"t4": "运费明细",
		"t5": "计费方式",
		"t6": "首重续重",
		"t7": "阶梯价格",
		"t8": "多级续重",
		"t9": "阶梯首重续重",
		"t10": "目的地",
		"t11": "重量",
		"t12": "体积",
		"t13": "运费",
		"t14": "计费标准",
		"t15": "首重",
		"t16": "续重",
		"t17": "最大限重",
	},
	"paylist": {
		"t1": "当前位置",
		"t2": "我的订单",
		"t3": "订单详情",
		"t4": "支付明细",
		"t5": "暂无相关信息",
		"t6": "图片",
		"t7": "付款说明",
		"t8": "付款账号",
		"t9": "交易号",
		"t10": "支付时间",
		"t11": "支付金额",
		"t12": "状态",
		"t13": "待审核",
		"t14": "审核通过",
		"t15": "审核不通过",
		"t16": "提交支付信息",
	},
	"payAdd": {
		"t1": "基础信息",
		"t2": "订单号",
		"t3": "入仓号",
		"t4": "应付",
		"t5": "已付",
		"t6": "未付",
		"t7": "付款金额",
		"t8": "请输入付款金额",
		"t9": "说明",
		"t10": "请输入说明",
		"t11": "其他信息",
		"t12": "付款账号",
		"t13": "请输入付款账号",
		"t14": "交易号",
		"t15": "请输入交易号",
		"t16": "上传截图",
		"t17": "保存",
		"t18": "请上传付款图片",
	},
	"ocang": {
		"t1": "当前位置",
		"t2": "快件下单",
		"t3": "选择仓库",
		"t4": "确定",
	},
	"ogoods": {
		"t1": "当前位置：",
		"t2": "快件下单",
		"t3": "编辑货物",
		"t4": "添加货物",
		"t5": "运输信息",
		"t6": "品名",
		"t7": "请输入品名",
		"t8": "重量(kg)",
		"t9": "请输入重量",
		"t10": "数量",
		"t11": "请输入数量",
		"t12": "尺寸(m³)",
		"t13": "请输入",
		"t14": "长 cm",
		"t15": "宽 cm",
		"t16": "高 cm",
		"t17": "体积(m³)",
		"t18": "请输入体积",
		"t19": "PCS",
		"t20": "请输入PCS",
		"t21": "货值(rmb)",
		"t22": "请输入货值",
		"t23": "货物类型(可多选)",
		"t24": "请选择",
		"t25": "商品状况",
		"t26": "全新",
		"t27": "二手",
		"t28": "翻新",
		"t29": "快递单号",
		"t30": "请输入快递单号",
		"t31": "上传照片",
		"t32": "修改",
		"t33": "添加",
		"t34": "请填写品名",
		"t35": "请输入数量",
		"t36": "请选择货物类型",
		"t37": "是",
		"t38": "否",
	},
	"opage": {
		"t1": "出发仓",
		"t2": "选择仓库",
		"t3": "收件人",
		"t4": "选择仓位",
		"t5": "请选择",
		"t6": "选择国家",
		"t7": "联系电话",
		"t8": "请输入联系电话",
		"t9": "唛头",
		"t10": "请选择唛头",
		"t11": "选择唛头",
		"t12": "运输信息",
		"t13": "运输方式",
		"t14": "报关方式",
		"t15": "收货方式",
		"t16": "备注",
		"t17": "请输入备注",
		"t18": "付款人",
		"t19": "供应商名称",
		"t20": "请输入供应商名称",
		"t21": "供应商电话",
		"t22": "请输入供应商手机号码",
		"t23": "增值服务",
		"t24": "汽车需要的资料",
		"t25": "是否汽车",
		"t26": "登记证",
		"t27": "点击上传，PDF或者图片",
		"t28": "查看",
		"t29": "合同",
		"t30": "其他",
		"t31": "公里数图片",
		"t32": "行驶证",
		"t33": "许可证",
		"t34": "公里数",
		"t35": "请输入公里数",
		"t36": "联系方式",
		"t37": "请输入供车商联系方式",
		"t38": "货物信息",
		"t39": "添加",
		"t40": "暂无商品信息",
		"t41": "快递单号",
		"t42": "复制",
		"t43": "编辑",
		"t44": "修改",
		"t45": "下单",
		// 选项标签
		"o1": "我司全带",
		"o2": "自单代报",
		"o3": "自提",
		"o4": "派送",
		"o5": "发货人",
		"o6": "收货人",
		"o7": "双方支付",
		"o8": "是",
		"o9": "否",
		"o10": "请选择仓位",
		// 错误提示
		"e1": "请选择仓位",
		"e2": "请输入供应商电话",
		"e3": "请上传公里数图片",
		"e4": "请输入供车商联系方式",
		"e5": "选择国家",
		"e6": "请选择唛头",
		"e7": "请添加货物信息",
		"ge0": "品　　名",
		"ge1": "数　　量",
		"ge2": "体　　积",
		"ge3": "货　　值",
		"ge4": "货物类型",
		"ge5": "长",
		"ge6": "宽",
		"ge7": "高",
		"ge8": "我的购物车",
	}
}